import { useTranslation } from 'react-i18next';
import { Database } from 'lucide-react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { MasterDataTab } from '@/components/admin/MasterDataTab';

/**
 * Dedicated Stammdaten page for admins, group admins, and site admins. Admins
 * approve changes in the embedded queue; non-admins submit edits that land in
 * that queue for review.
 */
export default function MasterDataPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="master-data-page">
      <Header />
      <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-orange-600 flex items-center justify-center">
            <Database className="h-5 w-5" />
          </div>
          <div>
            <h1 className="font-manrope text-2xl font-bold" data-testid="master-data-title">
              {t('masterData.title', 'Stammdaten-Pflege')}
            </h1>
            <p className="text-sm text-muted-foreground">
              {t('masterData.subtitle', 'Lieferantenartikel, technische Daten und Datenblätter — zentral verwaltet mit Freigabe-Workflow.')}
            </p>
          </div>
        </div>
        <MasterDataTab />
      </div>
      <Footer />
    </div>
  );
}
